import DatePicker from "@/components/DatePicker/index";
import MultiSelectCheckbox from "@/components/MultiSelectCheckbox/index";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

const FilterRow = React.forwardRef(({ "data-testid": dataTestId, filter, preFilter, setPreFilter }, ref) => {
	const [options, setOptions] = useState(filter?.options)

	useEffect(() => {
		// require value, name, id, else throw error
		if (filter?.options?.some(s => !s?.value || !s?.name || !s?.id)) {
			throw new Error('options must have id, name, value')
		}
	}, [filter?.options])

	useEffect(() => {
		if (filter.type === 'multiSelect' || filter.type === 'select') {
			setOptions(filter?.options?.map(s => {
				return {
					...s,
					$selected: preFilter?.[filter.key]?.findIndex(f => f?.id === s?.id) > -1
				}
			}))
		}
	}, [preFilter])

	if (filter.type === 'multiSelect') {
		return (
			<div className="data_table__filterrow" key={filter.key}>
				<span className="filter_row__title">
					{filter.label}
				</span>
				<div className="filter_row__option">
					<MultiSelectCheckbox
						data-testid={`${dataTestId}-multiSelect`}
						items={options}
						onChangeFunc={(selected) => {
							console.log('selected', selected)
							setPreFilter({
								...preFilter,
								[filter.key]: selected.filter(s => s.$selected),
							});
						}}
					/>
				</div>
			</div>
		)
	} else if (filter.type === 'dateRange') {
		return (
			<div className="data_table__filterrow" key={filter.key}>
				<span className="filter_row__title">
					{filter.label}
				</span>
				<div className="filter_row__option">
					{/* {//use DatePicker component instead, startDate and endDate in different component} */}
					<div className="filter_row__daterange">
						<DatePicker
							data-testid={`${dataTestId}-startDate`}
							selectDate={preFilter?.startDate}
							setSelectDate={(date) => {
								setPreFilter({
									...preFilter,
									startDate: date,
								});
							}}
							placeHolderText="Start Date"
							dateFormat={"dd/MM/yyyy"}
							showTimeSelect={false}
						/>
						<DatePicker
							data-testid={`${dataTestId}-endDate`}
							selectDate={preFilter?.endDate}
							setSelectDate={(date) => {
								setPreFilter({
									...preFilter,
									endDate: date,
								});
							}}
							placeHolderText="End Date"
							dateFormat={"dd/MM/yyyy"}
							showTimeSelect={false}
						/>
					</div>
				</div>
			</div>
		)
	}
});

FilterRow.propTypes = {
	"data-testid": PropTypes.string,
	filter: PropTypes.object.isRequired,
	preFilter: PropTypes.object.isRequired,
	setPreFilter: PropTypes.func.isRequired,
};

export default FilterRow;
